export interface ActiveConsultation {
  id: number | string;
  stage?: string | null;
  status?: string | null;
  encToken?: string | null;
}

const ACTIVE_STAGES = ["initial", "payment", "final-confirm", "chat"];

export const isActiveConsultation = (t?: ActiveConsultation | null): t is ActiveConsultation =>
  Boolean(t?.id && t.stage && ACTIVE_STAGES.includes(t.stage));

export const activeConsultationRoute = (t: ActiveConsultation): string => {
  const encToken = t.encToken || "";

  switch (t.stage) {
    case "initial":
      return `/connect-doctor/${t.id}/${encToken}?stage=initial`;
    case "payment":
      return `/checkout-teleconsultation/${t.id}`;
    case "final-confirm":
      return `/connect-doctor/${t.id}/${encToken}?stage=final-confirm`;
    default:
      return `/chat/${t.id}/${encToken}`;
  }
};

export const activeConsultationMessage = (t: ActiveConsultation): string => {
  switch (t.stage) {
    case "initial":
      return "Permintaan konsultasi Anda sebelumnya masih menunggu dokter menerima. Selesaikan atau tunggu permintaan tersebut sebelum membuat konsultasi baru.";
    case "payment":
      return "Dokter sudah menerima konsultasi Anda sebelumnya dan menunggu pembayaran. Selesaikan pembayaran tersebut sebelum membuat konsultasi baru.";
    case "final-confirm":
      return "Anda sudah membayar konsultasi sebelumnya dan sedang menunggu dokter memulai. Anda dapat menunggu atau memilih dokter lain dari halaman konsultasi tersebut.";
    default:
      return "Anda masih memiliki konsultasi yang sedang berlangsung.";
  }
};
